import { CardClassSelectors } from '@square/web-payments-sdk-types'

import { pickBy } from '.'

import { isSSR } from './isSSR'

const AVAILABLE_FONTS = [
  'andale mono',
  'arial',
  'arial black',
  'arial narrow',
  'arial rounded mt bold',
  'avant garde',
  'baskerville',
  'big caslon',
  'bodoni mt',
  'book antiqua',
  'brush script mt',
  'calibri',
  'calisto mt',
  'cambria',
  'candara',
  'century gothic',
  'charcoal',
  'comic sans ms',
  'consolas',
  'copperplate',
  'copperplate gothic light',
  'courier',
  'courier new',
  'cursive',
  'didot',
  'fantasy',
  'franklin gothic medium',
  'futura',
  'garamond',
  'geneva',
  'georgia',
  'gill sans',
  'goudy old style',
  'helvetica',
  'helvetica neue',
  'hoefler text',
  'impact',
  'lucida bright',
  'lucida console',
  'lucida grande',
  'lucida sans unicode',
  'lucida sans typewriter',
  'monaco',
  'monospace',
  'optima',
  'palatino',
  'palatino linotype',
  'papyrus',
  'perpetua',
  'rockwell',
  'rockwell extra bold',
  'sans-serif',
  'segoe ui',
  'serif',
  'tahoma',
  'times',
  'times new roman',
  'trebuchet ms',
  'verdana',
] as const

type AvailableFonts = (typeof AVAILABLE_FONTS)[number]

const squareElementStyles = (): CardClassSelectors | undefined => {
  if (isSSR) return
  const styledInput = document.querySelector('.js-checkout-styled-input')
  if (!styledInput) return

  const themeInputStyles = window.getComputedStyle(styledInput)

  const fonts = AVAILABLE_FONTS.reduce((obj, font) => {
    const index = themeInputStyles.fontFamily.toLowerCase().indexOf(font)
    if (index > -1) {
      obj[index] = font
    }
    return obj
  }, {} as { [index: number]: AvailableFonts })

  const fontFamily = fonts[Math.min(...Object.keys(fonts).map(Number))] || 'helvetica neue'

  const { backgroundColor, color, fontSize, fontWeight, borderColor, borderWidth, borderRadius } = themeInputStyles

  const inputStyles = pickBy({ backgroundColor, color, fontSize, fontWeight, fontFamily })
  const inputContainerIsFocusStyles = pickBy({ borderColor, borderWidth })
  const inputContainerStyles = pickBy({ ...inputContainerIsFocusStyles, borderRadius })
  const inputPlaceholderColor = themeInputStyles.getPropertyValue('--placeholder_color').trim()

  return {
    input: inputStyles,
    'input::placeholder': {
      color: inputPlaceholderColor || 'rgba(0, 0, 0, 0.5)',
    },
    '.input-container': inputContainerStyles,
    '.input-container.is-focus': inputContainerIsFocusStyles,
  }
}

export default squareElementStyles
